<template>
<!-- 产品列表中心 -->
  <div class="productMain">
    <PcProductMainList class="PC"/>
    <MdProductMainList class="MD"/>
  </div>
</template>

<script>
// 移动端
import MdProductMainList from './MdProductMainList.vue'
// pc端
import PcProductMainList from './PcProductMainList.vue'
// 引入根路径
import request from '@/utils/request'
// 获取产品
import { getProduct } from '@/api/product'
export default {
  name: 'productMain',
  components: {
    PcProductMainList,
    MdProductMainList
  },
  data () {
    return {
      baseUrl: '', // g根路径
      productList: [] // 产品
    }
  },
  created () {
    this.baseUrl = request.defaults.baseURL
    this.getProduct()
  },
  mounted () {
    this.getProduct()
  },
  methods: {
    // 获取产品
    async getProduct () {
      const res = await getProduct({ TypeId: 0, PageIndex: 1 })
      // console.log(res, 'chan产品')
      if (res.Msg === '获取成功') {
        this.productList = res.Data
        this.productList.forEach(item => {
          item.TitlePic = this.baseUrl + item.TitlePic
        })
        this.$store.commit('getProductList', this.productList)
        localStorage.setItem('productList', JSON.stringify(this.productList))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .productMain{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .productMain{
    .MD{
      display: none;
    }
  }
}
</style>
